<template>
  <v-app>
    <v-col>
      <ValidationObserver
        ref="pollValidation"
        v-slot="{ invalid, passes }">
        <v-row>
          <v-col cols="6">
            <v-text-field
              disabled
              class="mt-0 pt-0"
              label="Jméno"
              :value="poll.result ? poll.result.firstName : ''" />
          </v-col>
          <v-col cols="6">
            <v-text-field
              disabled
              class="mt-0 pt-0"
              label="Příjmení"
              :value="poll.result ? poll.result.lastName : ''" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              disabled
              class="mt-0 pt-0"
              label="Telefonní kontakt"
              :value="poll.result ? poll.result.phone.prefix + poll.result.phone.number: ''" />
          </v-col>
          <v-col cols="6">
            <v-text-field
              disabled
              class="mt-0 pt-0"
              label="E-mail"
              :value="poll.result ? poll.result.email : ''" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-row justify="space-between">
              <v-col class="pt-0">
                <v-text-field
                  v-model="form.SSNstart"
                  class="mt-0 pt-0"
                  label="Rodné číslo"
                  type="number" />
              </v-col>
              <v-col
                cols="auto"
                class="mt-1 pt-0">
                /
              </v-col>
              <v-col class="pt-0">
                <v-text-field
                  v-model="form.SSNend"
                  class="mt-0 pt-0"
                  type="number" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="datePickerMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px">
              <template v-slot:activator="{ on }">
                <VTextFieldWithValidation
                  custom-class="mt-0 pt-0"
                  :rules="'required'"
                  v-model="computedDateFormatted"
                  label="Datum narození"
                  mode="lazy"
                  prepend-icon="event"
                  readonly
                  v-on="on" />
              </template>
              <v-date-picker
                ref="datePickerMenu"
                locale="cs"
                color="blue lighten-1"
                v-model="birthday"
                @input="datePickerMenu = false"
                :show-current="false"
                :max="new Date().toISOString().substr(0, 10)"
                min="1920-01-01"
                :first-day-of-week="1" />
            </v-menu>
          </v-col>
          <v-col
            cols="auto">
            <v-btn @click="submit()"
                   type="submit"
                   x-large
                   depressed
                   height="68px"
                   class="px-12 white--text"
                   color="blue lighten-1">
              Uložit
            </v-btn>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<style>
@import url('https://fonts.googleapis.com/css?family=Material+Icons');
</style>

<script>
/* eslint-disable prefer-destructuring */
export default {
  name: 'ThePersonalInformation',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      poll: {},
      form: {
        userId: this.$store.state['vue-auth'].user
          ? this.$store.state['vue-auth'].user.id
          : '',
        healthRisksAtWork: {
          status: '',
          value: ''
        },
        SSNstart: '',
        SSNend: ''
      },
      datePickerMenu: false,
      birthday: '',
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10))
    };
  },
  computed: {
    computedDateFormatted: {
      get() {
        return this.formatDate(this.birthday);
      },
      set() {

      }
    },
    SSN() {
      return this.form.SSNstart + this.form.SSNend;
    },
    formtosend() {
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user
          ? this.$store.state['vue-auth'].user.id
          : '',
        SocialSecurityNumber: `${this.form.SSNstart}/${this.form.SSNend}`,
        DateOfBirth: `${this.birthday}T00:00:00.000Z`
      });
    }
  },
  watch: {
    datePickerMenu(val) {
      // eslint-disable-next-line no-unused-expressions
      val
        // eslint-disable-next-line no-return-assign
        && setTimeout(() => (this.$refs.datePickerMenu.activePicker = 'YEAR'));
    },
    birthday() {
      this.dateFormatted = this.formatDate(this.birthday);
    }
  },
  methods: {
    formatDate(birthday) {
      if (!birthday) return null;

      const [year, month, day] = birthday.split('-');
      return `${day}.${month}.${year}`;
    },
    parseDate(birthday) {
      if (!birthday) return null;

      const [month, day, year] = birthday.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        this.$store.dispatch('poll/toggleErrorModal', true);
        return false;
      }

      this.axios.put('admin/questionnaires/personalinformation', {
        CustomerId: this.id,
        SocialSecurityNumber: `${this.form.SSNstart}/${this.form.SSNend}`,
        DateOfBirth: `${this.birthday}T00:00:00.000Z`,
        UserId: 1
      }).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  created() {
    this.axios.get('admin/questionnaires/personalinformation', {
      params: {
        CustomerId: this.id
      }
    }).then((res) => {
      this.poll = res.data;
      const data = res.data.result;
      const SSN = data.socialSecurityNumber ? data.socialSecurityNumber.split('/', 2) : ['', ''];
      this.form.SSNstart = SSN[0];
      this.form.SSNend = SSN[1];
      this.birthday = data.dateOfBirth ? data.dateOfBirth.split('T', 1)[0] : '';
    });

    // this.$store.dispatch('poll/getPersonalInformation', this.$store.state['vue-auth'].user.id)
    //   .then(response => {
    //     const data = response.data.result
    //     const SSN = data.socialSecurityNumber ? data.socialSecurityNumber.split('/', 2) : ['', '']
    //     this.form.SSNstart = SSN[0]
    //     this.form.SSNend = SSN[1]
    //     this.birthday = data.dateOfBirth ? data.dateOfBirth.split('T', 1)[0] : ''
    //   })
    // this.$emit('submit', () => () => {
    //   return this.axios.put('questionnaire/personalinformation', this.formtosend)
    // })
  }
};
</script>
